import React from "react";
import logger from "logger";

export const StringValue = ({ label, value, valueParser = (v) => v }) => {
  if (!value) {
    return null;
  }
  return (
    <div>
      <div className="infokey">{label}</div>
      <div className="infovalue">{valueParser(value)}</div>
    </div>
  );
};
